// Imports
// React and ReactDOM
import React from 'react';
import ReactDOM from 'react-dom/client';

// Third-party libraries
import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { sessionStorage } from 'aws-amplify/utils';
import { parseAmplifyConfig } from 'aws-amplify/utils';

// Components
import App from './App.tsx';

// Project-level imports
import outputs from '../amplify_outputs.json';
import { createLogger } from './utils/logger';

// Styles
import './index.css';

// Constants
const logger = createLogger('main');
const amplifyConfig = parseAmplifyConfig(outputs);
logger.debug('amplifyConfig', amplifyConfig);

const config = {
  ...amplifyConfig,
  API: {
    ...amplifyConfig.API,
    REST: outputs.custom.API,
  },
  Auth: {
    Cognito: {
      userPoolId: outputs.auth.user_pool_id,
      userPoolClientId: outputs.auth.user_pool_client_id,
      signUpVerificationMethod: 'code' as const,
      loginWith: {
        email: true,
        phone: true,
      },
      userAttributes: {
        address: {
          required: true,
        },
        preferred_username: {
          required: true,
        },
        'custom:profileType': {
          required: true,
        },
      },
    },
  },
};
logger.debug('config', config);

Amplify.configure(config);
cognitoUserPoolsTokenProvider.setKeyValueStorage(sessionStorage);

/**
 * Main entry point for the application
 * Sets up the Amplify configuration and renders the App component
 * @returns The main entry point
 */
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
